import { useCallback } from 'react';
import { useMemo } from 'react';
import { useState } from 'react';
import { SqlServerIntegration } from 'libs/end-to-end/src/types/databases/integrations/sql-server-integration';
import { SqlServerIntegrationTable } from 'libs/end-to-end/src/types/databases/integrations/sql-server-integration';
import { SqlServerIntegrationQuery } from 'libs/end-to-end/src/types/databases/integrations/sql-server-integration';
import { Setter } from 'libs/end-to-end/src/ui-types';
import { SecretReference } from 'libs/end-to-end/src/types/secrets/secret-reference';

export interface DataSetEditSqlServerIntegrationHook {
  sqlServerIntegration: SqlServerIntegration;
  setSqlServerIntegration: Setter<SqlServerIntegration>;
}

export const useDataSetEditSqlServerIntegration =
  (): DataSetEditSqlServerIntegrationHook => {
    const [tableList, setTableList] = useState<SqlServerIntegrationTable[]>([]);
    const [queryList, setQueryList] = useState<
      SqlServerIntegrationQuery[] | undefined
    >(undefined);
    const [host, setHost] = useState<string>('');
    const [port, setPort] = useState<number>(1433);
    const [requestTimeoutInSeconds, setRequestTimeoutInSeconds] = useState<number | undefined>(undefined);

    const [userSecretReference, setUserSecretReference] =
      useState<SecretReference | null>(null);
    const [passwordSecretReference, setPasswordSecretReference] =
      useState<SecretReference | null>(null);

    const setSqlServerIntegration = useCallback(
      (sqlServerIntegration: SqlServerIntegration) => {
        setTableList(sqlServerIntegration.tables);
        setQueryList(sqlServerIntegration.queries);
        setHost(sqlServerIntegration.host);
        setPort(sqlServerIntegration.port);
        setUserSecretReference(sqlServerIntegration.user ?? null);
        setPasswordSecretReference(sqlServerIntegration.password ?? null);
        setRequestTimeoutInSeconds(sqlServerIntegration.requestTimeoutInSeconds);
      },
      [],
    );

    return useMemo(() => {
      return {
        sqlServerIntegration: {
          integrationType: 'SqlServer',
          password: passwordSecretReference ?? undefined,
          host,
          port,
          tables: tableList,
          queries: queryList,
          user: userSecretReference ?? undefined,
          requestTimeoutInSeconds: requestTimeoutInSeconds,
        },
        setSqlServerIntegration,
      };
    }, [
      host,
      passwordSecretReference,
      port,
      setSqlServerIntegration,
      tableList,
      queryList,
      userSecretReference,
      requestTimeoutInSeconds,
    ]);
  };
